export * from './lib/omni-table.module';
export * from './lib/models/column.model';
export * from './lib/models/config.model';
